// Constantes de las piezas de Promociones del wizard.
import type { ReferralPromotionChannel } from './api/wizardPromotionsContract';

/** Tope de espera de `afterReferral`; al vencer, el wizard sigue al cobro. */
export const AFTER_REFERRAL_TIMEOUT_MS = 5_000;

/** Cada cuánto se vuelve a pedir el cupón mientras se genera. */
export const COUPON_POLL_MS = 3_000;

/** Lecturas del cupón antes de dejar de reintentar solo (unos 30 s). */
export const COUPON_MAX_POLLS = 10;

/** Prefijo en sessionStorage de los nombres de promos y regalos vistos en una sesión del wizard. */
export const PROMOTION_NAMES_STORAGE_PREFIX = 'fiado.promotions-wizard.names.';

/** Sondeo del Wallet de la promo de venta mientras no tiene desenlace: rápido el primer minuto. */
export const WALLET_POLL_FAST_MS = 5_000;
export const WALLET_POLL_FAST_READS = 12;

/** Después del primer minuto, cada minuto hasta unos 20 en total. */
export const WALLET_POLL_SLOW_MS = 60_000;
export const WALLET_POLL_MAX_READS = WALLET_POLL_FAST_READS + 19;

/** Motivo bajo «Continuar» mientras se cargan o apartan las promos. */
export const PROMOTIONS_CONFIRMING_REASON = 'Confirmando promociones…';

/** Motivo bajo «Continuar» si no se pudieron cargar las promos. */
export const PROMOTIONS_RETRY_REASON = 'Reintenta cargar las promociones.';

/** Título del aviso de que el cliente llegó recomendado. */
export const REFERRED_BY_NOTICE_LABEL = 'Llegó recomendado';

/** Título de la tabla de promos de referido vigentes del paso Referidos. */
export const LIVE_REFERRAL_PROMOTIONS_LABEL = 'Promos de referido vigentes';

/** Etiqueta de dónde vive cada promo de referido. */
export const REFERRAL_CHANNEL_LABEL: Record<ReferralPromotionChannel, string> = {
    SALE: 'Venta',
    CREDIT: 'Crédito',
};

/** Prefijo en sessionStorage de lo marcado en «Elige el teléfono» y el «Sin promo», por sesión. */
export const PHONE_DRAFT_STORAGE_PREFIX = 'fiado.promotions-wizard.draft.';

/** Motivo bajo «Continuar» mientras falte el regalo de una promo marcada en el 04. */
export const GIFT_PENDING_REASON = 'Falta elegir el regalo';
